import React from "react";
import { LoaderCircle, RefreshCw } from "lucide-react";
import { Link } from "react-router";
import { withInvoiceReturn } from "../../utils/consolidationOrderNavigation.js";
import { dayWords } from "../../utils/billingPeriods.js";

export default function InvoiceConsolidationNotice({ refresh, sync, canManage, busy, dirty, buttonClassName, invoiceId }) {
  const state = refresh?.state;
  if (!refresh && !sync.error && !sync.deferred) return null;
  if (state === "current" && !sync.error && !sync.deferred && !sync.updating && !sync.updated) return null;
  const waiting = state === "waiting_validation";
  const failed = Boolean(sync.error) || state === "blocked";
  let message = "Mise à jour du brouillon depuis Consolidation…";
  if (sync.deferred) message = sync.conflict
    ? "Le relevé a changé. Vos saisies sont conservées. Annulez les changements pour charger sa nouvelle version."
    : "Une actualisation est en attente. Terminez vos modifications pour afficher les nouvelles données.";
  else if (sync.error) message = sync.error;
  else if (waiting) message = "Validez les modifications dans Consolidation. Ce brouillon sera ensuite actualisé automatiquement.";
  else if (state === "blocked") message = "La mise à jour du brouillon est bloquée. Corrigez les éléments indiqués ci-dessous.";
  else if (state === "ready" && !canManage) message = "Ce brouillon doit être actualisé par une personne autorisée à gérer les brouillons.";
  else if (sync.updated && !sync.updating) message = "Brouillon mis à jour depuis Consolidation.";
  const tone = failed ? "border-red-200 bg-red-50 text-red-900"
    : waiting || sync.deferred ? "border-amber-200 bg-amber-50 text-amber-900"
      : "border-slate-200 bg-slate-50 text-slate-700";
  return <section role={failed ? "alert" : "status"} className={`mb-2 rounded-[4px] border px-2.5 py-2 text-xs ${tone}`}>
    <div className="flex flex-wrap items-center gap-2">
      {sync.updating ? <LoaderCircle size={14} className="shrink-0 animate-spin" aria-hidden="true" /> : null}
      <p className="min-w-[12rem] flex-1 font-semibold">{message}</p>
      {failed && (!waiting || sync.error) && canManage ? <button type="button" className={`${buttonClassName} h-7 rounded-[4px] px-2 text-xs`}
        disabled={busy || dirty || sync.updating} onClick={sync.retry}><RefreshCw size={13} />Réessayer la mise à jour</button> : null}
    </div>
    {refresh?.reasons?.length ? <ul className="mt-1 space-y-1">{refresh.reasons.map((reason, index) => <li key={`${reason.code}-${index}`}>
      {reason.message}{reason.url ? <> <Link className="font-bold text-accent underline" to={withInvoiceReturn(reason.url, invoiceId)}>Ouvrir Consolidation du {dayWords(reason.date)}</Link></> : null}
    </li>)}</ul> : null}
  </section>;
}
